import React from 'react'
import { Container } from '../home/styles'
import styled from 'styled-components'
import jpgFile from './header/cover-mockup-no-bg.jpg'

const Image = styled.img`
  position: absolute;
  z-index: -1;
  top: 50%;
  transform: translateY(-50%) scale(0.8);

  @media (max-width: 1200px) {
    top: 67%;
  }
`

const Heading = styled.h1`
  color: #2E4057;
`

const SubHeading = styled.h3`
  font-weight: normal;
  color: grey;
  line-height: 1.4em;
  text-transform: none;
  font-size: 1.25rem;
`

const HeaderContainer = styled(Container)`
  text-align: center;
  margin: 10em auto 0;
  align-items: center;
  min-height: 90vh;

  @media (max-width: 1200px) {
    margin-top: 5em;
  }
`

const QuoraText = styled.span`
  font-family: 'Karla', sans-serif;
  font-weight: 400;
  color: grey;
  font-size: .7em;
`

const Countdown = styled.div`
  font-size: 1.7em;
  text-transform: uppercase;
  background: #FFFC78;
  color: #2E4057;
  height: 8em;
  width: 8em;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10vh;
  left: 10vw;
  border-radius: 100%;

  @media (max-width: 1000px) {
    font-size: 1.3em;
  } 
`

export default class Header extends React.Component {
  state = {
    daysLeft: 5
  }

  componentDidMount() {
    const oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date();
    const secondDate = new Date(2019,3,10);

    const daysLeft = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));

    this.setState({daysLeft})
  }

  render() {
    return (
      <HeaderContainer>
        <Image src={jpgFile} alt="Book Cover"/>
        <hgroup>
          <Heading>The Ultimate Guide to Quora Marketing<br/><QuoraText>by Emil Bruckner</QuoraText></Heading>
          <SubHeading>All tactics <br/>One book</SubHeading>
          <Countdown>Available now!</Countdown>
        </hgroup>
      </HeaderContainer>
    )
  }
}
